import { Box, IconButton, Tooltip } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import Icons from '../../../components/icons';
import { DeclarationItem } from '../types';

export const getDeclarationColumns = (
  onEdit: (rowDeclarationData: DeclarationItem) => void,
  onDelete: (declarationItem: DeclarationItem) => void,
  onLabelClick: (declarationItem: DeclarationItem) => void
): GridColDef[] => {
  return [
    { field: 'sequenceNo', headerName: 'Sequence No', flex: 1 },
    {
      field: 'label',
      headerName: 'Label',
      flex: 1,
      renderCell: (params) => {
        return (
          <Box
            onClick={() => onLabelClick(params.row)}
            sx={{ cursor: 'pointer', textDecoration: 'underline' }}
          >
            {params.row.label}
          </Box>
        );
      }
    },
    {
      field: 'edit',
      headerName: 'Actions',
      sortable: false,
      minWidth: 120,
      headerAlign: 'center',
      renderCell: (params) => (
        <Box>
          <Tooltip title='Edit'>
            <IconButton onClick={() => onEdit(params.row)}>
              <Icons.EditBlackOutlined />
            </IconButton>
          </Tooltip>
          <Tooltip title='delete'>
            <IconButton onClick={() => onDelete(params.row)}>
              <Icons.Delete />
            </IconButton>
          </Tooltip>
        </Box>
      )
    }
  ];
};
